import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export function ComposerDropdownCaret() {
    return _jsx(Icon, { icon: $icon('chevron-down'), size: "tiny", color: "ultraLight" });
}
//# sourceMappingURL=ComposerDropdownCaret.js.map